// extracted by mini-css-extract-plugin
module.exports = {"Container":"NotFound_Container__1owVJ","Status":"NotFound_Status__1AiYa","Message":"NotFound_Message__2YimM"};